export const DOCTOR_REQUEST="DOCTOR_REQUEST"
export const DOCTOR_FAILURE="DOCTOR_FAILURE"
export const GET_DOCTOR_SUCCESS="GET_DOCTOR_SUCCESS"
export const POST_DOCTOR_SUCCESS="POST_DOCTOR_SUCCESS"
export const DELETE_DOCTOR_SUCCESS="DELETE_DOCTOR_SUCCESS"
export const PATCH_DOCTOR_SUCCESS="PATCH_DOCTOR_SUCCESS"

